import React from 'react';
export function LeadershipSection() {
  const leadership = [{
    id: 1,
    title: 'Robotics Club',
    period: '2022-2024',
    description: ['Build, CAD, Teaching teams', 'FIRST Tech Challenge competition', 'Collaborated in subteams of 5-10 people']
  }, {
    id: 2,
    title: 'California Scholarship Federation',
    period: '2021-2024',
    description: ['Park cleanups, fundraisers, community events', 'Transcription for National Archives and Smithsonian']
  }, {
    id: 3,
    title: 'Rotary ELC Alumni Network Committee Member',
    period: 'Apr 2024 - Present',
    description: ['Organizing events', 'Maintaining internship list for alumni', 'Improving organization websites']
  }, {
    id: 4,
    title: 'National Honors Society',
    period: '2022-2024',
    description: ['Tutored high school students in STEM subjects', 'Specialized in AP Calculus AB/BC, AP Physics 1']
  }, {
    id: 5,
    title: 'Infinity Club',
    period: 'Aug 2020 - Jun 2021',
    description: ['Free one-on-one online math tutoring to elementary students', 'Used Khan Academy and Zoom whiteboard']
  }];
  return <section className="section-spacing bg-background-light" data-id="element-105">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-107">
          Volunteering
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-108">
          Community involvement and leadership roles
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-109">
          {leadership.map(item => <div key={item.id} className="card p-6 hover:translate-y-[-5px]" data-id="element-110">
              <h3 className="text-xl font-display font-bold mb-1" data-id="element-111">
                {item.title}
              </h3>
              <p className="text-primary mb-4" data-id="element-112">{item.period}</p>
              <ul className="list-disc pl-5 text-text-secondary" data-id="element-113">
                {item.description.map((desc, index) => <li key={index} className="mb-1" data-id="element-114">
                    {desc}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}